export const ARROW_DOWN = 'caret-down';

export const ARROW_UP = 'caret-up';

export const DENTAL_REASON_ID = {
  checkup: 'checkup',
  services: 'services',
  urgent: 'not-urgent', // No idea why this isn't just 'urgent' but this lines up with the ID patient tiering uses ¯\_(ツ)_/¯
};

export const DENTAL_SERVICES = {
  checkup: {
    name: 'New patient exam & Cleaning',
    description:
      'The clinic will book you in for an initial visit, which consists of an examination by the dentist, a set of X-rays, and a cleaning with a hygienist.',
  },
  urgent: {
    name: 'Urgent Issue',
    description:
      'Treatment of urgent issues typically consist of a diagnostic examination with the dentist and X-rays to help diagnose your issue. From there, the dentist can determine what additional treatment you may require and give you a cost estimate accordingly.',
  },
  2: {
    description: 'Bonding',
  },
  3: {
    description: 'Braces',
  },
  5: {
    description: 'Bridges / Dentures',
  },
  9: {
    description: 'Crown / Cap',
  },
  16: {
    description: 'Cavity / Filling',
  },
  12: {
    description: 'Gum Surgery',
  },
  8: {
    description: 'Implants',
  },
  6: {
    description: 'Nitrous Sedation',
  },
  10: {
    description: 'Root Canal',
  },
  13: {
    description: 'Sleep Apnea',
  },
  14: {
    description: 'TMJ',
  },
  11: {
    description: 'Tooth Extraction',
  },
  1: {
    description: 'Veneers',
  },
  7: {
    description: 'Whitening',
  },
  4: {
    description: 'Wisdom Teeth Removal',
  },
};

export const FEATURES = {
  wifi: 5,
  kidFriendly: 9,
  publicTransitAccessible: 12,
  digitalXrays: 14,
  dentalAnxietyFriendly: 16,
  intraOralCamera: 17,
  financing: 19,
};

export const NAVIGATION_BAR_TABS = {
  about: 'about',
  needToKnow: 'needToKnow',
  office: 'office',
  reviews: 'reviews',
};

export const PROFILE_ACHIEVEMENT_SECTION_TYPES = {
  awards: 'awards',
  educationCertifications: 'educationCertifications',
};

export const PROFILE_ACHIEVEMENT_TYPES = {
  association: 'ASSOCIATION',
  awards: 'AWARDS',
  certification: 'CERTIFICATION',
  education: 'EDUCATION',
};

export const PROFILE_INSIGHT_TYPES = {
  dentalAnxietyFriendly: 'dentalAnxietyFriendly',
  earlyAvailability: 'earlyAvailability',
  eveningAvailability: 'eveningAvailability',
  firstResponseTimeHours: 'firstResponseTimeHours',
  highlyExperienced: 'highlyExperienced',
  newPatients: 'newPatients',
  patientsChoice: 'patientsChoice',
  responseRate: 'responseRate',
  scheduleRate: 'scheduleRate',
  seeYouSoon: 'seeYouSoon',
  weekendAvailability: 'weekendAvailability',
};

export const PROFILE_COVID_SAFETY_PROCEDURE_NAMES = {
  airPurificationSystems: 'Air Purification Systems',
  patientPreScreening: 'Patient Pre-Screening',
  additionalPPE:
    'Additional personal protective equipment (PPE) face shields, masks, gowns, gloves',
  plexiglassAtReceptionArea: 'Plexiglass at reception area',
  prePayAppointments: 'Pre-pay Appointments',
  telehealthOptions: 'Tele-health Options',
  appointmentSpacing: 'Appointment spacing to eliminate patient interaction',
  temperatureCheck: 'Temperature check upon entering',
  closedDoor: 'Closed door for each operatory',
  hospitalGradeDisinfectant: 'Hospital grade disinfectant between each patient',
  additionalSanitizationStations: 'Additional santization stations available',
};
